document.addEventListener('DOMContentLoaded', function () {
    const buttons = document.querySelectorAll('.show-more')

    if (buttons.length > 0) {
        buttons.forEach(function (button) {
            button.addEventListener('click', function (event) {
                const targetToggleElementSelector = button.getAttribute('data-element-toggle')
                const targetToggleElement = document.querySelector(targetToggleElementSelector)

                const targetScrollElementSelector = button.getAttribute('data-element-scroll')
                const targetScrollElement = document.querySelector(targetScrollElementSelector)

                if (targetToggleElement) {
                    if (targetToggleElement.classList.contains('folded')) {
                        targetToggleElement.classList.remove('folded')
                        targetToggleElement.classList.add('unfolded')

                        button.innerHTML = button.getAttribute('data-text-secondary')
                    } else {
                        targetToggleElement.classList.add('folded')
                        targetToggleElement.classList.remove('unfolded')

                        button.innerHTML = button.getAttribute('data-text-primary')
                    }
                }

                if (targetScrollElement) {
                    const headerElement = document.querySelector('.page-header')
                    const elementOffsetTop = targetScrollElement.getBoundingClientRect().top + window.pageYOffset
                    const headerHeight = headerElement ? headerElement.offsetHeight : 0

                    window.scrollTo({
                        top: elementOffsetTop - headerHeight,
                        behavior: 'smooth'
                    })
                }
            })
        })
    }
})
